import { render, staticRenderFns } from "./RouterMenu.vue?vue&type=template&id=70f57f26&scoped=true"
import script from "./RouterMenu.vue?vue&type=script&lang=js"
export * from "./RouterMenu.vue?vue&type=script&lang=js"
import style0 from "./RouterMenu.vue?vue&type=style&index=0&id=70f57f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f57f26",
  null
  
)

export default component.exports